import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { whatsappLink } from "@/constants/site";
import { portfolioFilters, portfolioProjects } from "@/mocks/criacao-sites";

export default function PortfolioSection() {
  const [active, setActive] = useState(portfolioFilters[0]);
  const projects =
    active === "Todos"
      ? portfolioProjects
      : portfolioProjects.filter((project) => project.category === active);

  return (
    <section id="portfolio" className="scroll-mt-24 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          badge="Portfólio"
          badgeIcon="ri-image-2-line"
          badgeTone="accent"
          title="Conheça alguns projetos"
          description="Uma amostra do nosso padrão de desenvolvimento para diferentes segmentos e tipos de projeto."
        />

        <Reveal>
          <div className="mt-10 flex justify-center">
            <div className="flex flex-wrap justify-center gap-1 rounded-full border border-background-200 bg-background-100 p-1">
              {portfolioFilters.map((filter) => {
                const isActive = active === filter;
                return (
                  <button
                    key={filter}
                    type="button"
                    onClick={() => setActive(filter)}
                    aria-pressed={isActive}
                    className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                      isActive
                        ? "bg-primary-500 text-background-50"
                        : "text-foreground-700 hover:bg-background-200/70"
                    }`}
                  >
                    {filter}
                  </button>
                );
              })}
            </div>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {projects.map((project, index) => (
            <Reveal key={project.title} delay={index * 60} className="h-full">
              <article className="group flex h-full flex-col overflow-hidden rounded-xl border border-background-200 bg-background-100/40 transition-colors hover:border-primary-200">
                <div className="relative h-52 w-full overflow-hidden bg-background-100">
                  <img
                    src={project.image}
                    alt={`Projeto ${project.title} desenvolvido pela NXHOST`}
                    title={`${project.title} — criação de sites NXHOST`}
                    loading="lazy"
                    decoding="async"
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
                  />
                  <span className="absolute left-3 top-3 inline-flex items-center gap-1.5 rounded-full bg-background-50/90 px-3 py-1 text-[11px] font-semibold text-foreground-800 backdrop-blur-sm">
                    <i className="ri-folder-3-line text-primary-600" aria-hidden="true"></i>
                    {project.type}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <h3 className="font-heading text-base font-semibold text-foreground-950">
                    {project.title}
                  </h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                    {project.description}
                  </p>
                  <a
                    href={whatsappLink(
                      `Ola! Vi o projeto ${project.title} da NXHOST e quero um site parecido para a minha empresa.`
                    )}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-4 inline-flex items-center gap-2 self-start whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-xs font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
                  >
                    Ver projeto
                    <i className="ri-arrow-right-up-line" aria-hidden="true"></i>
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <p className="mt-8 text-center text-xs text-foreground-500">
            Projetos ilustrativos para demonstrar o nosso padrão de desenvolvimento.
          </p>
        </Reveal>
      </div>
    </section>
  );
}